import { Helmet, HelmetProvider } from 'react-helmet-async';
import { Spinner } from "@heroui/react";
import AlmostRentedUnitsTable from "shared/components/rental/sections/almost-rented-units-table";
import VacantUnitsTable from "shared/components/rental/sections/vacant-units-table";
import UpcomingVacantUnitsTable from "shared/components/rental/sections/upcoming-vacant-units-table";
import UnitsInRenovationTable from "shared/components/rental/sections/units-in-renovation-table";
import { PageInfoBanner } from "shared/components/walkthrough/PageInfoBanner";
import {
  useVacantUnits,
  useUpcomingVacantUnits,
  useUnitsInRenovation,
  useAlmostRentedUnits
} from "../../hooks";

const Vacancies = () => {
  const {
    vacantUnits,
    isLoading: isLoadingVacant,
    refetch: fetchVacantUnits
  } = useVacantUnits();

  const {
    upcomingVacantUnits,
    isLoading: isLoadingUpcoming,
    refetch: fetchUpcomingVacantUnits
  } = useUpcomingVacantUnits();

  const {
    unitsInRenovation,
    isLoading: isLoadingRenovation,
    refetch: fetchUnitsInRenovation
  } = useUnitsInRenovation();

  const {
    almostRentedUnits,
    isLoading: isLoadingAlmost,
    refetch: fetchAlmostRentedUnits
  } = useAlmostRentedUnits();

  const isLoading = isLoadingVacant || isLoadingUpcoming || isLoadingRenovation || isLoadingAlmost;

  if (isLoading) {
    return (
      <div className="flex h-[400px] items-center justify-center bg-neutral-50">
        <Spinner
          size="lg"
          color="primary"
          label="Leegstand gegevens laden..."
          classNames={{
            wrapper: "flex flex-col items-center gap-4",
            circle1: "border-b-moss-primary",
            label: "text-moss-primary font-medium"
          }}
        />
      </div>
    );
  }

  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>Leegstand | Yally</title>
        </Helmet>
      </HelmetProvider>

      <div className="grid gap-6">
        <PageInfoBanner pageId="leegstand" />

        <AlmostRentedUnitsTable
          almostRentedUnits={almostRentedUnits}
          fetchAlmostRentedUnits={fetchAlmostRentedUnits}
          fetchUnitsInRenovation={fetchUnitsInRenovation}
        />

        <VacantUnitsTable
          fetchUnitsInRenovation={fetchUnitsInRenovation}
          vacantUnits={vacantUnits}
          fetchVacantUnits={fetchVacantUnits}
        />

        <UpcomingVacantUnitsTable
          fetchUnitsInRenovation={fetchUnitsInRenovation}
          upcomingVacantUnits={upcomingVacantUnits}
          fetchUpcomingVacantUnits={fetchUpcomingVacantUnits}
        />

        <UnitsInRenovationTable
          unitsInRenovation={unitsInRenovation}
          fetchVacantUnits={fetchVacantUnits}
          fetchUpcomingVacantUnits={fetchUpcomingVacantUnits}
          fetchUnitsInRenovation={fetchUnitsInRenovation}
        />
      </div>
    </>
  );
};

export default Vacancies;
